/* This file was generated automatically. Do not edit manually. */

export enum EnterpriseType {
    Hotel = 'Hotel',
    Hostel = 'Hostel',
    Apartments = 'Apartments',
    Spa = 'Spa',
    Shop = 'Shop',
    Villas = 'Villas',
    Resort = 'Resort',
    Motel = 'Motel',
    CruiseShip = 'CruiseShip',
    Campsite = 'Campsite',
    Portfolio = 'Portfolio',
}
